import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {redirectAction} from "~/redux/actions/redirect";
import {Redirect} from "react-router-dom";
import { useQuery } from './helpers/utils';
import { setCurrentLanguage } from './redux/actions/translations';

const AppRedirect = (props) => {
    const query = useQuery();
    const langQuery = query.get('lang');

    useEffect(() => {
        if(langQuery && props.languages.length > 0) {
            props.dispatch(
                setCurrentLanguage(props.languages.find(lang => lang.code === langQuery) || 'en')
            )
        }
    }, [])

    if (props.redirect && props.redirect.url) {
        props.dispatch(redirectAction(null));
        return <Redirect to={props.redirect.url} />
    }

    return props.children;
}

const mapStateToProps = (state) => ({
    languages: state.translations.languages,
    redirect: state.redirect,
});

export default connect(mapStateToProps)(AppRedirect);
